import { useState, useEffect } from "react";
import { api } from "../lib/api";

export function useMgmtOptions() {
  const [opts, setOpts] = useState({
    employees: [], branches: [], verticals: [], services: [], products: [],
    courses: [], campaigns: [], platforms: [], audience_types: [], creative_types: [], goal_types: [],
  });
  useEffect(() => {
    (async () => {
      const types = ["verticals", "services", "products", "courses", "campaigns", "platforms", "audience_types", "creative_types", "goal_types"];
      const [emp, br, ...masters] = await Promise.all([
        api.get("/mgmt/employees", { params: { status: "Active" } }),
        api.get("/branches"),
        ...types.map((t) => api.get(`/mgmt/masters/${t}`)),
      ]);
      const m = {};
      types.forEach((t, i) => { m[t] = masters[i].data; });
      setOpts({ employees: emp.data, branches: br.data, ...m });
    })().catch(() => {});
  }, []);
  return opts;
}

export function datePreset(preset) {
  const t = new Date();
  const iso = (d) => d.toISOString().slice(0, 10);
  let start = new Date(t), end = new Date(t);
  if (preset === "today") { /* same */ }
  else if (preset === "yesterday") { start.setDate(t.getDate() - 1); end.setDate(t.getDate() - 1); }
  else if (preset === "this_week") { start.setDate(t.getDate() - ((t.getDay() + 6) % 7)); }
  else if (preset === "last_week") { const s = new Date(t); s.setDate(t.getDate() - ((t.getDay() + 6) % 7) - 7); start = s; end = new Date(s); end.setDate(s.getDate() + 6); }
  else if (preset === "this_month") { start = new Date(t.getFullYear(), t.getMonth(), 1); }
  else if (preset === "last_month") { start = new Date(t.getFullYear(), t.getMonth() - 1, 1); end = new Date(t.getFullYear(), t.getMonth(), 0); }
  return { start: iso(start), end: iso(end) };
}
